import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";
import { SelectModule } from "primeng/select";
import { ILanguage } from "app/types/language";
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'op-language-selector',
  templateUrl: "./opLanguageSelector.view.html",
  styleUrl: "./opLanguageSelector.style.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectModule, FormsModule]
})
export class OpLanguageSelector {

  public readonly languages = input.required<ILanguage[]>();
  public readonly current = input.required<ILanguage>();
  public readonly currentChange = output<ILanguage>();
  protected readonly langModel = computed(() => this.current().language);

  protected _change(event: string) {
    const selectedLanguage = event;
    if (selectedLanguage == this.current().language) return;
    const languageObject = this.languages().find(lang => lang.language === selectedLanguage);
    if (languageObject) {
      this.currentChange.emit(languageObject);
    }
  }
}
